/**
 * Return on recruiting spend as a gross multiple: gross profit ÷ recruiting
 * costs. Callers pass the net ROI percentage, (gain − cost) ÷ cost × 100, so
 * the multiple is that ratio plus one: a 1,527% net ROI reads as 16.27x.
 */
export function roiMultiple(netRoiPercent: number): string {
  if (!Number.isFinite(netRoiPercent)) return '—'
  const value = netRoiPercent / 100 + 1
  const text = Math.abs(value).toFixed(2) + 'x'
  return value < 0 ? '−' + text : text
}
